// extracted by mini-css-extract-plugin
export default {"root":"Customer_root__kTPcS"};